import Model from './Model';

export default class extends Model {
  static data() {
    return {
      id: '',
      name: '',
      check_in: '',
      check_out: '',
      location: {
        lat: '',
        lng: '',
        name: '',
      },
      project_id: '',
      stripe_token: '',
      tour_type_id: '',
    };
  }
  async checkoutCustomTrip(data) {
    let url = `/custom-trips/stripe`;
    return this.postPromise(url, data)
      .then((response) => {
        return response;
      })
      .catch((error) => {
        $showError(
          error.response.data.message || 'something went wrong!',
          'checkout-toast'
        );
      });
  }

  async checkoutBulkCustomTrip(data) {
    let url = `/custom-trips/stripe/bulk`;
    return this.postPromise(url, data)
      .then((response) => {
        return response;
      })
      .catch((error) => {
        $showError(
          error.response.data.message || 'something went wrong!',
          'checkout-toast'
        );
      });
  }

  async getBulkCheckoutAmount(data) {
    let url = `/custom-trips/bulk/estimate`;
    return this.postPromise(url, data)
      .then((response) => {
        return response;
      })
      .catch((error) => {
        $showError(
          error.response.data.message || 'something went wrong!',
          'checkout-toast'
        );
      });
  }

  async get() {
    let url = '/custom-trips?' + this.getParamsAsQueryParam();
    return this.getPromise(url).catch((error) =>
      $showError(
        error.response.data.message || 'something went wrong!',
        'fetch-groups'
      )
    );
  }

  async fetchSightings(groupID) {
    let url =
      `/custom-trip/${groupID}/sightings?` + this.getParamsAsQueryParam();
    return this.getPromise(url).catch((error) => {
      $showError(
        error.response.data.message || 'something went wrong!',
        'fetch-group-sightings'
      );
    });
  }
}
